/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { Platform } from 'react-native';

export const ACTIONS = {
  tap: 'tap',
  click: 'click',
  view: 'screen_view_v2',
  select: 'select',
  unselect: 'unselect',
  screenView: 'view',
  selectFilter: 'select_filter',
  selectAddOn: 'select_addon',
};

export const EVENT_NAMES = {
  createTrip: 'create_trip',
  dateSelection: 'date_selection',
  stationSelection: 'station_selection',
  search: 'search',
  editSearch: 'edit_search',
  selectFilter: 'select_filter',
  flightDetails: 'select_flight_details',
  viewListing: 'view_listing',
  selectFlight: 'select_flight',
  get selectAddon() {
    return Platform.OS === 'web' ? 'select_addon' : 'click';
  },
  bookingConfirmationAction: 'booking_confirmation_action',
  selectBundle: 'aa_flt_ancillarybundle_selected',
  viewBundle: 'aa_flt_ancillarybundle_viewed',
  compareBundleBenefit: 'compare_bundle_benefit',
  bundleUnavailable: 'bundle_unavailable',
  get baggageAction() {
    return Platform.OS === 'web' ? 'baggage_action' : 'select_addon';
  },
  viewCarbonOffset: 'viewCarbonOffset',
  companyDetails: 'company_details',
  paxDetails: 'pax_details',
  fastPassAction: 'fastPassAction',
  checkoutPageViewed: 'aa_flt_checkout_pageviewed',
  guestDetailsSubmitted: 'aa_flt_guestdetails_submitted',
  snapBundleBannerImpression: 'view',
  snapBundleBannerClick: 'click',
  snapBundleBannerDismiss: 'tap',
  snapBundleOfferView: 'view',
  snapBundleOfferInteract: 'tap',
  snapBundleFallback: 'view',
  bookingSuccessful: 'aa_flt_booking_successful',
  thinListingSeeMoreBundles: 'thin_listing_see_more_bundles',
  thinListingViewBundles: 'aa_flt_ancillarybundle_viewed',
  thinListingSelectBundle: 'aa_flt_ancillarybundle_selected',
  aa_flt_paymentpage_loaded: 'aa_flt_paymentpage_loaded',
  aa_flt_mmb_error: 'aa_flt_mmb_error',
  addToCart: 'add_to_cart',
  guestHeatmapClick: 'click',
  aa_flt_guest_details_submitted: 'aa_flt_guest_details_submitted',
  flightSoldOut: 'aa_flt_flight_sold_out',
};

export const CATEGORY = {
  projectLink: 'Project Link',
  flightBaseCurrency: 'Flight|Base Currency',
  flightMultiCurrency: 'Flight|Multi Currency',
  searcgWidgetNotFoung: 'hpsearchwidget|not found',
  flightSearchWidget: 'Flights|flightsearchwidget',
  homepageDatepicker: 'hpsearchwidget|datepicker',
  flightSearchListEdit: 'Flight Select Edit',
  flightSearchListHeatmap: 'Flight Select heatmap',
  flightSelectFilterHeatmap: 'flightselectheatmap',
  flightAddOnHeatmap: 'Addon heatmap',
  flightsAddonsHeatmap: 'flight|add ons heatmap',
  flightsMotHeatmap: 'flight|guest details heatmap|mot',
  bookingConfirmation: 'Booking Confirmation',
  bookingConfirmationHeatmap: 'Booking Confirmation heatmap',
  addonsBundleHeatmap: 'ancillary|in path|bundles heatmap',
  addons: 'addons',
  carbonOffset: 'flight|add ons heatmap|carbonoffset',
  specialCoverageInsurance: 'flight|add ons heatmap|coverage',
  insuranceType: 'flight|add ons heatmap|insurance',
  specialAssistance: 'flight|add ons heatmap|specialassistance',
  selectAddon: 'flight|add ons heatmap|mmb',
  recommendedSeat: 'flight|add ons heatmap|seat',
  mealSelection: 'flight|add ons heatmap|meal',
  baggageSelection: 'flight|add ons heatmap|baggage',
  pageViewed: 'flights|checkout|mmb',
  guestDetailsHeatmap: 'flight|guest details heatmap',
  guestDetailsMoreGuestHeatmap: 'flight|guest details heatmap|more guest',
  contactDetailsHeatmap: 'flight|contact details heatmap',
  companyDetailsHeatmap: 'flight|company details heatmap',
  flightSelectHeatmapAligned: 'flight select heatmap',
  specialAssistanceHeatmap: 'flight|add ons heatmap|specialassistance',
  insurance: 'add ons heatmap|insurance',
  seatTogetherSelection: 'flight|add ons heatmap|seat_together',
  fastPassSelection: 'flight|add ons heatmap|fastpass',
};

export const ANALYTICS_CONSTANTS = {
  FLIGHTS: 'Flights',
  FLIGHT: 'Flight',
  HOME: 'Home',
  AA: 'aa',
  OTA: 'OTA',
  CITY: 'city',
  AIRPORT: 'airport',
  FLIGHT_SEARCH_WIDGET: 'flightsearchwidget',
  ORIGIN: 'origin',
  DEST: 'dest',
  HP_SEARCH_WIDGET: 'hpsearchwidget',
  DATE_PICKER: 'datepicker',
  FLIGHTS_OTA: 'Flights OTA',
  DATE_FORMAT: 'yyyy-MM-dd',
  RT: 'RT',
  OW: 'OW',
  DOMESTIC: 'Domestic',
  INTERNATIONAL: 'International',
  LOB_CONSUMER_NAME: 'LOB / Consumer Name',
  VIEW_DETAILS: 'view details',
  DEPART: 'depart',
  RETURN: 'return',
  FLIGHT_CARD: 'flightcard',
  BUNDLE: 'bundle',
  MYKAD: 'mykad',
  MYKAD_FIND_OUT_MORE: 'find out more',
  MYKAD_VERIFIED: 'mykad verified successfully',
};

export const SCREEN_NAME = {
  flightSearchWidget: 'Flight Search Widget V2',
  home: 'Home V2',
  flightSearchList: 'Flight Select V2',
  bookingConfirmation: 'Flight Booking Confirmation V2',
  bookingConfirmationV2: 'MMB Booking Confirmation V2',
  guestDetails: 'Guest Details V2',
  mmbAddons: 'MMB Addons V2',
  changeFlight: 'Change Flight V2',
};

export const EVENTS = {
  trackEventNoEcommerce: 'trackEventNoEcommerce',
  aaSearchInitiated: 'aa_flt_search_initiated',
  aaSelect: 'aa_flt_select_actions',
  purchase: 'purchase',
  aaFlightsAddon: 'aa_flights_addon',
  aaFlightsAddonSpecialAssistance: 'aa_flights_addon_specialassistance',
  aaBundleViewed: 'aa_flt_ancillarybundle_viewed',
  aaViewItemList: 'view_item_list',
  aaSelectItem: 'select_item',
};

export const GTM_LOB = {
  DOTREZ: 'Dotrez',
  KIWI: 'Kiwi',
  VIETJET: 'Vietjet',
};

export const AIRLINES = {
  AIRASIA: 'airasia',
  ALL_AIRLINES: 'all airlines',
};
